import type { PipelineCardDetail as PipelineCardDetailDto } from '@/pages/pipelines/common/types';

import {
  DetailLabel,
  DetailSection,
  DetailTimelineItem,
  DetailTimelineList,
  DetailTimelineMeta,
  DetailTimelineText,
  DetailTimelineTitle,
} from './styled';

type TimelineItem = PipelineCardDetailDto['timeline'][number];

export const PipelineDetailTimeline = ({ items }: { items: TimelineItem[] }) => (
  <DetailSection>
    <DetailLabel>Timeline</DetailLabel>
    <DetailTimelineList>
      {items.map((item, index) => (
        <DetailTimelineItem
          key={`${item.stage}-${item.reachedAt ?? 'pending'}-${index}`}
          data-highlighted={item.highlighted}
        >
          <DetailTimelineText>
            <DetailTimelineTitle>{item.label}</DetailTimelineTitle>
            {item.reachedAt && (
              <DetailTimelineMeta>{formatTimestamp(item.reachedAt)}</DetailTimelineMeta>
            )}
            {item.note && <DetailTimelineMeta>{item.note}</DetailTimelineMeta>}
          </DetailTimelineText>
        </DetailTimelineItem>
      ))}
    </DetailTimelineList>
  </DetailSection>
);

const formatTimestamp = (isoDate: string) =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date(isoDate));
